import {
  LayoutDashboard,
  CalendarDays,
  Trophy,
  Layers,
  LineChart,
  Cpu,
  Sparkles,
  MapPin,
  Users,
  CreditCard,
  Package,
  DollarSign,
  Percent,
  Gift,
  Receipt,
  Share2,
  Mail,
  ShieldCheck,
  Settings,
  Palette,
  AlertTriangle,
  MessageSquare,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Match nested routes (e.g. /meetings/:id) as active too. */
  end?: boolean;
  /** Show a live count beside the label. */
  badge?: 'unread-messages';
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Overview',
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true }],
  },
  {
    label: 'Racing',
    items: [
      { to: '/meetings', label: 'Meetings', icon: CalendarDays },
      { to: '/predicted-exotics', label: 'Predicted Exotics', icon: Trophy },
      { to: '/multis', label: 'Multis', icon: Layers },
      { to: '/racing-analytics', label: 'Racing Analytics', icon: LineChart },
      { to: '/analysis-models', label: 'Analysis Models', icon: Cpu },
      { to: '/ai-prompts', label: 'AI Prompts', icon: Sparkles },
      { to: '/tracks', label: 'Tracks', icon: MapPin },
    ],
  },
  {
    label: 'Customers',
    items: [
      { to: '/users', label: 'Users', icon: Users },
      { to: '/messages', label: 'Messages', icon: MessageSquare, badge: 'unread-messages' },
      { to: '/subscriptions', label: 'Subscriptions', icon: CreditCard },
      { to: '/subscription-packages', label: 'Packages', icon: Package },
    ],
  },
  {
    label: 'Revenue & Growth',
    items: [
      { to: '/revenue', label: 'Revenue', icon: DollarSign },
      { to: '/discounts', label: 'Discounts', icon: Percent },
      { to: '/promotions', label: 'Promotions', icon: Gift },
      { to: '/stripe-price-mappings', label: 'Stripe Prices', icon: Receipt },
      { to: '/affiliates', label: 'Affiliates', icon: Share2 },
      { to: '/marketing', label: 'Marketing', icon: Mail },
    ],
  },
  {
    label: 'System',
    items: [
      { to: '/admin-users', label: 'Admin Users', icon: ShieldCheck },
      { to: '/errors', label: 'Errors', icon: AlertTriangle },
      { to: '/system-settings', label: 'Settings', icon: Settings },
      { to: '/brand-settings', label: 'Brand', icon: Palette },
    ],
  },
];
